<template>
  <div v-click-outside="() => (isOpen = false)" class="select-wrapper">
    <div class="select-controls">
      <font-awesome-icon
        :icon="hasValue ? 'times' : 'plus'"
        @click="hasValue ? clear() : (isOpen = true)"
      />
      <div class="label" @click="isOpen = !isOpen">{{ labelText }}</div>
      <font-awesome-icon :icon="isOpen ? 'chevron-up' : 'chevron-down'" @click="isOpen = !isOpen" />
    </div>
    <ul :class="isOpen ? 'open' : 'closed'">
      <li
        v-for="option in options"
        :key="option.value"
        :class="isSelected(option) ? 'selected' : ''"
        @click="onClick(option)"
      >
        {{ option.label }}
      </li>
    </ul>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';

function validator(options) {
  // each element in the array must be an object with at least the keys 'value' and 'label'
  if (!Array.isArray(options)) return false;
  for (let i = 0; i < options.length; i++) {
    let e = options[i];
    if (typeof e !== 'object' || !e.value || !e.label) return false;
  }
  return true;
}

export default {
  name: 'TolSelect',
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    options: {
      type: Array,
      required: true,
      validator
    },
    selected: {
      type: Array,
      default: () => [],
      validator
    },
    placeholder: {
      type: String,
      default() {
        return this.$t('components.select.defaults.placeholder');
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    multiSelectLabel: {
      type: String,
      default() {
        return this.$t('components.select.defaults.multiSelectLabel');
      }
    }
  },
  data() {
    return {
      // value is always an array of the selected values.
      // if multiple is false, then this is a single-select,
      // and value is an array of length 1
      value: this.selected,
      isOpen: false
    };
  },
  computed: {
    hasValue() {
      return this.value.length > 0;
    },
    labelText() {
      if (!this.hasValue) return this.placeholder;
      if (this.multiple) return this.value.length + ' ' + this.multiSelectLabel;
      return this.value[0].label;
    }
  },
  methods: {
    isSelected(option) {
      return !!this.value.find(e => e.value === option.value);
    },
    onClick(option) {
      if (this.multiple) {
        let index = this.value.findIndex(e => e.value === option.value);

        if (index === -1) {
          // not found, add it
          this.value.push(option);
        } else {
          // found, delete it
          this.value.splice(index, 1);
        }

        let valuesArray = [];
        this.value.forEach(v => {
          valuesArray.push(v.value);
        });

        this.$emit('change', valuesArray);
      } else {
        this.value = [option];
        this.isOpen = false;
        this.$emit('change', this.value[0].value);
      }
    },
    clear() {
      this.value = [];
      this.isOpen = false;
      this.$emit('change', this.multiple ? [] : null);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/colors.scss';
@import '../styles/variables.scss';

.select-wrapper {
  position: relative;
  cursor: pointer;
  display: flex;
  //flex: 1;

  .select-controls {
    display: flex;
    flex: 1;
    flex-direction: row;
    border: 1px solid $dark-blue;
    white-space: nowrap;
    padding: 6px 3px;

    > .fa-plus {
      color: $text-color-dark-3;
    }

    > .fa-times {
      color: $red;
    }

    > .fa-chevron-down,
    .fa-chevron-up {
      color: $text-color-dark;
      margin-left: auto;
    }

    > .label {
      display: inline;
      font-family: $font-family;
      font-weight: bold;
      color: $text-color-dark;
      border: none;
      font-size: 12px;
      padding: 0px 6px;
    }
  }

  > ul {
    position: absolute;
    min-width: 100%;
    list-style: none;
    margin: 0px;
    padding: 0px;
    background: $white;
    display: none;
    z-index: 100;

    &.open {
      display: block;
    }

    > li {
      color: $text-color-dark;
      border: 1px solid $text-color-dark;
      margin-top: -1px;
      padding: 10px 20px;
      white-space: nowrap;

      &.selected {
        font-weight: bold;
        color: $text-color-light-hover;
        background: $button-color-dark;
      }
    }
  }
}

@media only screen and (min-width: 768px) {
  .select-wrapper {
    //background-color: red;
  }
}
</style>
